module.exports = __webpack_public_path__ + "img/MELA_CD8T.673dbfe7.png";